import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import { type Payload } from 'echarts/lib/util/types';
import { type ElementAnimateConfig } from 'zrender/lib/Element.js';
import type RoamModel from './RoamModel';
import type RoamView from './RoamView';

interface RoamPayload extends Payload {
  dx?: number;
  dy?: number;
  zoomDelta?: number;
  zoomX?: number;
  zoomY?: number;
  animation?: boolean | ElementAnimateConfig;
}

export function installRoamAction(registers: EChartsExtensionInstallRegisters) {
  registers.registerAction(
    {
      type: 'dvRoam',
      event: 'dvRoamAction',
      update: 'none'
    },
    (payload: RoamPayload, ecModel, api) => {
      ecModel.eachComponent(
        {
          mainType: 'roam',
          query: payload
        },
        (componentModel: RoamModel) => {
          const view = api.getViewOfComponentModel(componentModel) as unknown as RoamView;

          if (typeof payload.dx !== 'undefined' || typeof payload.dy !== 'undefined') {
            view.updateAllViewOnPanAndZoom(
              { dx: payload.dx ?? 0, dy: payload.dy ?? 0 },
              payload.animation,
              true
            );
          }
          if (typeof payload.zoomDelta !== 'undefined') {
            view.updateAllViewOnPanAndZoom(
              { zoomDelta: payload.zoomDelta, zoomX: payload.zoomX, zoomY: payload.zoomY },
              payload.animation,
              true
            );
          }
        }
      );
    }
  );
}
